import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>🌸 플라워 플랫폼</h3>
          <p>최고의 화환을 제공하는 온라인 쇼핑몰</p>
          <div className="footer-links">
            <a href="/terms">이용약관</a> | <a href="/privacy"><strong>개인정보처리방침</strong></a> | <a href="/policy/refund">취소·환불 정책</a>
          </div>
        </div>
        <div className="footer-section">
          <h4>고객센터</h4>
          <p>전화: 010-3782-8997</p>
          <p>이메일: flowerplatform26@gmail.com</p>
          <p>운영시간: 평일 09:00 - 18:00</p>
        </div>
        <div className="footer-section">
          <h4>사업자 정보</h4>
          <p>상호: 주식회사 플라워 플랫폼 | 대표자: 곽도현</p>
          <p>사업자등록번호: 510-88-03725</p>
          <p>통신판매업신고: 제 2026-대구수성구-0776 호</p>
          <p>주소: 대구광역시 수성구 청수로26길 46, 1동 8층 801-A호 (두산동)</p>
          <p>개인정보보호책임자: 곽도현</p>
          <div className="escrow-mark">
            <span>[구매안전서비스 가입 사실 확인]</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Flower Platform. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

